module.exports = __webpack_public_path__ + "static/media/applyPic.80b26253.png";